import type { FC, ReactNode } from "react";

export interface SettingsTableSectionHeaderProps {
  children: ReactNode;
}

export const SettingsTableSectionHeader: FC<SettingsTableSectionHeaderProps> = (
  props,
) => (
  <tr>
    <td
      className="px-4 pt-4 pb-2 text-xs font-semibold text-muted-foreground"
      colSpan={100}
    >
      {props.children}
    </td>
  </tr>
);
